import React from 'react';
import {ThemeProvider} from 'styled-components';
import {Link} from 'react-router-dom';

import {List, ListItem, Window, WindowContent, WindowHeader} from 'react95';

import GlobalStyles from './GlobalStyles';
import peggyPastels from "react95/dist/themes/peggysPastels";
import djPhoto from "../assets/photos/dj.jpg";
import urbexPhoto from "../assets/photos/urbex.jpg";
import workshopPhoto from "../assets/photos/workshop.jpg";
import musicPhoto from "../assets/photos/music.jpg";

import "../../src/global.css";

const AboutMe = () => (
    <body style={{textAlign: "center", padding: "5%"}}>
        <div className="application">
            <GlobalStyles/>
            <ThemeProvider theme={peggyPastels}>
                <Window className='app-window'>
                    <WindowHeader active={true} className='window-header'>
                        <span>about me</span>
                    </WindowHeader>
                    <WindowContent>
                        <p style={{
                            margin: '0 0 16px 0',
                            padding: '8px',
                            fontSize: '1.1em',
                            lineHeight: '1.8',
                            textAlign: 'left'
                        }}>
                            <span style={{fontWeight: '900', textShadow: '0.2px 0 currentColor, -0.2px 0 currentColor'}}>hi, i'm eva! as of 2026:</span><br/>
                            <br/>
                            &nbsp;&nbsp;* i'm 27 yrs old<br/>
                            &nbsp;&nbsp;* i live in tel aviv<br/>
                            &nbsp;&nbsp;* i am the founding devops engineer in an <span style={{textTransform: 'none'}}>AI</span> security startup<br/>
                            <br/>
                            <span style={{fontWeight: '900', textShadow: '0.2px 0 currentColor, -0.2px 0 currentColor'}}>my passions these days are:</span><br/>
                            &nbsp;&nbsp;* 🔗 <Link to='/dj-sets' style={{color: 'inherit', textDecoration: 'underline', textTransform: 'none'}}><span style={{textTransform: 'none'}}>DJing</span> at house parties</Link><br/>
                            &nbsp;&nbsp;* urbex (aka urban exploration)<br/>
                            &nbsp;&nbsp;* organizing 🔗 <Link to='/workshops' style={{color: 'inherit', textDecoration: 'underline'}}>workshops</Link> at mah crib (mainly painting)<br/>
                            &nbsp;&nbsp;* maintaining my 🔗 <a href='https://www.instagram.com/tel.aviv.history' target='_blank' rel='noreferrer' style={{color: 'inherit', textDecoration: 'underline'}}>@tel.aviv.history</a> page<br/>
                            &nbsp;&nbsp;* producing 🔗 <Link to='/my-music' style={{color: 'inherit', textDecoration: 'underline'}}>electronic music</Link><br/>
                            &nbsp;&nbsp;* riding bicycle 15± km a day<br/>
                            <br/>
                            <span style={{fontWeight: '900', textShadow: '0.2px 0 currentColor, -0.2px 0 currentColor'}}>
                                pls ping me in one of my 🔗 <Link to='/social' style={{color: 'inherit', textDecoration: 'underline'}}>social pages</Link> if you wanna collab!
                            </span>
                        </p>
                        <figure style={{margin: '0 auto 16px auto', maxWidth: '600px', textAlign: 'center'}}>
                            <img src={djPhoto} alt="i DJ sometimes" style={{width: '100%', display: 'block'}}/>
                            <figcaption style={{marginTop: '6px', fontSize: '0.95em', fontStyle: 'italic'}}>i <span style={{textTransform: 'none'}}>DJ</span> sometimes</figcaption>
                        </figure>
                        <figure style={{margin: '0 auto 16px auto', maxWidth: '600px', textAlign: 'center'}}>
                            <img src={urbexPhoto} alt="urbex session" style={{width: '100%', display: 'block'}}/>
                            <figcaption style={{marginTop: '6px', fontSize: '0.95em', fontStyle: 'italic'}}>a very wild urbex session. notice there's a huge hole in the floor</figcaption>
                        </figure>
                        <figure style={{margin: '0 auto 16px auto', maxWidth: '600px', textAlign: 'center'}}>
                            <img src={workshopPhoto} alt="a painting workshop at mah crib" style={{width: '100%', display: 'block'}}/>
                            <figcaption style={{marginTop: '6px', fontSize: '0.95em', fontStyle: 'italic'}}>a painting workshop at mah crib</figcaption>
                        </figure>
                        <figure style={{margin: '0 auto 16px auto', maxWidth: '600px', textAlign: 'center'}}>
                            <img src={musicPhoto} alt="producing music in the underground bomb shelter" style={{width: '100%', display: 'block'}}/>
                            <figcaption style={{marginTop: '6px', fontSize: '0.95em', fontStyle: 'italic'}}>producing music in the bomb shelter cause of the <span style={{textTransform: 'none'}}>IRGC</span> 😮‍💨</figcaption>
                        </figure>
                        <List className={'window-list'}>
                            <ListItem as={Link}
                                      className={'list-item-style-override'}
                                      to='/'>
                                ← back
                            </ListItem>
                        </List>
                    </WindowContent>
                </Window>
            </ThemeProvider>
        </div>
    </body>
);

export default AboutMe;
